import React, { Component } from 'react';
import Firebase from 'firebase';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import AddUser from './addUser';
import UserPrueba from './userPrueba'


var ReactToastr = require("react-toastr");
var { ToastContainer } = ReactToastr;
var ToastMessageFactory = React.createFactory(ReactToastr.ToastMessage.animation);



export default class usuarios extends React.Component {
    constructor() {
        super();
        this.state = {
            user: {},
            users: {},
            limit: true
        }
        this.callBack = this.callBack.bind(this);
        this.deleteUser = this.deleteUser.bind(this);
    }

    componentDidMount() {
        var usersRef = Firebase.database().ref('clients_users').child(localStorage.client_id).on('value', snap => {
            if (snap.val()) {
                this.setState({ users: snap.val() })
            } else {
                this.setState({ limit: false })
            }
        })
        var userRef = Firebase.database().ref('admin_users').child(localStorage.uid)
            .on('value', resp => {
                this.setState({ user: resp.val() });
            });
        var clientRef = Firebase.database().ref('clients/' + localStorage.client_id);
        clientRef.on("value", snap => {
            if (snap.val().trial) {
                this.setState({ trial: true })
            }
        });
        this.setState({ token: JSON.parse(localStorage["firebase:authUser:AIzaSyBUBm9Ccl_mancuvJ34gKRjCJT9hdtg384:[DEFAULT]"]).stsTokenManager.accessToken });
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextState.users !== this.state.users && nextState.users) {
            if (Object.keys(nextState.users).length > 3 && this.state.trial) {
                this.setState({ limit: true })
            }else{
                this.setState({limit : false})
            }
        }
    }

    updateUsers() {
        this.setState({ users: {} });
        var userRef = Firebase.database().ref('admin_users').child(localStorage.uid)
            .once('value')
            .then(resp => {
                this.setState({ user: resp.val() });
                var clientRef = Firebase.database().ref('clients_users').child(localStorage.client_id).once('value')
                    .then(resp => this.setState({ users: resp.val() }));
            });
    }

    callBack(name) {
        this.refs.container.success(
            "Usuario añadido correctamente",
            name, {
                timeOut: 3000,
                extendedTimeOut: 10000
            });
        this.setState({ showModal: false });
        this.updateUsers();
    }

    deleteUser(id, user) {
        const usuario = user;
        const urlprox = 'https://us-central1-operatio-a399c.cloudfunctions.net/api/admin/deleteUser';
        const urldev = 'https://us-central1-operatio-pro-dev-493b8.cloudfunctions.net/api/admin/deleteUser';
        const data = {
            isAdmin: false,
            uid: id,
            client_id: localStorage.client_id
        };

        fetch(urldev, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + this.state.token
            }
        })
            .then((response) => {
                if (response.status === 200) {
                    var logRef = Firebase.database().ref("log/" + localStorage.client_id + "/");
                    var id = Firebase.database().ref().child('log').push().key;
                    logRef.child(id).set({
                        admin: localStorage.email,
                        timestamp: Firebase.database.ServerValue.TIMESTAMP,
                        action: "delete",
                        target: {
                            type: "user",
                            name: user
                        }
                    });
                    this.refs.container.success(
                        "USUARIO ELIMINADO",
                        "usuario eliminado correctamente", {
                            timeOut: 3000,
                            extendedTimeOut: 10000
                        });
                } if (response.status === 403) {
                    this.refs.container.warning(
                        "USUARIO NO FUE Eliminado",
                        "", {
                            timeOut: 3000,
                            extendedTimeOut: 10000
                        });
                }

            })
            .then(jsonResponse => {
                var logRef = Firebase.database().ref("log/" + localStorage.client_id + "/");
                var id = Firebase.database().ref().child('log').push().key;
                logRef.child(id).set({
                    admin: localStorage.email,
                    timestamp: Firebase.database.ServerValue.TIMESTAMP,
                    action: "delete",
                    target: {
                        type: "user",
                        name: user.name
                    }
                });
                this.refs.container.success(
                    "USUARIO ELIMINADO",
                    "usuario eliminado correctamente", {
                        timeOut: 3000,
                        extendedTimeOut: 10000
                    });
            })
            .catch(error => {
            });

    }

    render() {
        var arrayUsers = [];
        if (this.state.users) {
            arrayUsers = Object.keys(this.state.users);
        }
        return (
            <div className="animated fadeIn">
                <div className="row">
                    <div className="col-lg-12">
                        <ToastContainer
                            style={{ top: "60" }}
                            ref="container"
                            toastMessageFactory={ToastMessageFactory}
                            className="toast-top-right"
                        />
                        <div className="col col-xs-6 text-right">
                            {
                                !this.state.limit ?
                                    <button type="button" onClick={() => { this.setState({ showModal: true }) }} className="btn btn-outline-success">Nuevo Usuario</button>
                                    :
                                    <button type="button" className="btn btn-outline-success" onClick={() => {
                                        this.refs.container.warning(
                                            "Se ha superado el limite de usuarios posibles",
                                            "Versión de pruebas", {
                                                timeOut: 3000,
                                                extendedTimeOut: 10000
                                            });
                                    }}>Nuevo Usuario</button>
                            }
                        </div>
                        {
                            this.state.users ?
                                <UserPrueba users={this.state.users} callBack={(id, user) => this.deleteUser(id, user)} />
                                :
                                ""
                        }
                        <Modal isOpen={this.state.showModal} toggle={() => { this.setState({ showModal: false }) }} className="modal-content">
                            <ModalHeader toggle={() => { this.setState({ showModal: false }) }}>Nuevo usuario</ModalHeader>
                            <ModalBody>
                                <AddUser callBack={this.callBack} />
                            </ModalBody>
                        </Modal>
                    </div >
                </div>
            </div >
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/users/usuarios.js